import { render, staticRenderFns } from "./Failure.vue?vue&type=template&id=b8e60ea0&scoped=true&"
import script from "./Failure.vue?vue&type=script&lang=js&"
export * from "./Failure.vue?vue&type=script&lang=js&"
import style0 from "./Failure.vue?vue&type=style&index=0&id=b8e60ea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e60ea0",
  null
  
)

export default component.exports